<template>
  <div 
  class="streetview-target"
  v-on:click="openPallet"
  v-bind:style="style"
  :data-name="view"
  >
    <div class="streetview-target-inner">
      <span v-if="name != false" class="label">{{ name }}</span>
      <ul 
      class="pallet"
      v-bind:class="{'open': palletOpen}"
      >
        <li v-if="panorama" v-on:click="loadStreetview">360&deg;</li>
        <li 
        v-on:click="loadVideo"
        v-if="video"
        >&#9658;</li>
        <li class="close" v-on:click="closePallet">X</li>
      </ul>
    </div>
  
  </div>
</template>

<script>
export default {
  name: 'StreetViewTarget',
  props: {
    url: String,
    top: String,
    left: String,
    view: String,
    video: String,
    panorama: {
      type: Boolean,
      default: function(){
        return true;
      }
    },
    name: {
      type: String,
      default: function(){
        return ''
      }
    },
    displayName: Boolean,
    controlSettings: {
      type: Object,
      default: function(){
        return {
          xAxis: {
            min: 0,
            max: 360
          },
          yAxis: {
            min: 70,
            max: 110
          },
          xStart: 0
        }
      }
    }
  },
  data: function(){
    return {
      palletOpen: false
    }
  },
  methods: {
    closePallet(){
      let self = this;
      setTimeout(function(){
        self.palletOpen = false;
        self.$parent.currentPallet = false;
      }, 100);
    },
    openPallet(){
      this.palletOpen = true;
      this.$parent.currentPallet = this.view;
    },
    loadStreetview(){
      this.$parent.controlSettings = this.controlSettings;
      this.$parent.setViewerView(this.view)
    },
    loadVideo(){
      this.$parent.setVideoFile(this.view);
    }
  },
  computed: {
    style: function(){
      return {
        top: this.top + 'vw',
        left: this.left + 'vw'
      }
    }
  }
}
</script>

<style scoped>
.streetview-target {
  position: absolute;
  content: '';
  width: 3vw;
  height: 3vw;
  transform: translateX(30%) translateY(30%);
  border-radius: 50%;
  top: 0vw;
  left: 0vw;
  background: rgba(255,255,255,0.1);
  background: rgba(25, 99, 144, 0.16);
  border: 1px solid rgba(255,255,255,0.25);
  transition: background 0.25s;
  cursor: pointer;
  z-index: 200;
}
.streetview-target:hover {
  background: rgba(255,255,255,0.2);
}
.streetview-target:hover .streetview-target-inner .label {
  transform: translateX(-50%) translateY(0px);
  transition: all 0.25s;
  opacity: 1;
  display: inline;
}

.streetview-target-inner {
  width: 100%;
  height: 100%;
  position: relative;
}

.streetview-target-inner .label {
  opacity: 0;
  position: absolute;
  bottom: 100%;
  background: #00457c;
  color: #fff;
  font-weight: 700;
  width: 100px;
  line-height: 1.3em;
  padding: 0.5em 0.25em;
  font-size: 0.85em;
  transform: translateX(-50%) translateY(10px);
  transition: all 0.25s;
}

.pallet {
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  width: 0px;
  height: 0px;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  transform: translateX(-25%) translateY(-25%);
  opacity: 0;
  transition: opacity 0.25s;
  width: 100px;
  height: 100px;
  top: -200vh;
  z-index: 205;
}

.pallet.open {
  opacity: 1;
  top: 0vh;
}

.pallet li {
  width: 50%;
  height: 50%;
  display: inline-block;
  padding: 0;
  margin: 0;
  background: rgba(255,255,255,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #196390;
  color: #fff;
  font-weight: 700;
  box-shadow: 0px 0px 8px rgba(0,0,0,0.5);
}

.pallet li:nth-child(1){
  transform: translateX(-50%) translateY(-50%);
}
.pallet li:nth-child(2){
  transform: translateX(50%) translateY(-50%);
}
.pallet li:nth-child(3){
  transform: translateX(-50%) translateY(50%);
}
.pallet li:nth-child(4){
  transform: translateX(50%) translateY(50%);
}
.pallet li.close {
  background: url('../assets/close.png') center center no-repeat;
  background-color: #196390;
  background-size: 80% 80%;
  font-size: 0px;
}

</style>
